import styled from "styled-components";
import { useState, useEffect, useRef } from "react";
import { FaBullhorn, FaAward, FaHandshake, FaChevronLeft, FaChevronRight } from "react-icons/fa";

/* ─────────────────────────────────────────
   IMAGE SLOTS — replace null with require()
───────────────────────────────────────── */
const vidyalakshmiImage = require("../assets/images/summit/Vidyalakshmischolarship.webp");

const socialImpactAwardsCarousel = [];

const socialImpactCarousel = [
  require("../assets/images/summit/socialimpactaward1.webp"),
  require("../assets/images/summit/socialimpactaward2.webp"),
  require("../assets/images/summit/socialimpactaward3.webp"),
  require("../assets/images/summit/socialimpactaward4.webp"),
];

const socialImpactAwards = [
  {
    org: "Indian Oil Corporation Limited",
    project: "Solar Eri Spinning – Women-Led Sustainable Livelihood Initiative",
    desc: "Empowering over 2,500 women artisans in Meghalaya through clean energy-powered Eri silk spinning, sustainable livelihoods, and digital market access.",
  },
  {
    org: "Ford Business Solutions India",
    project: "Go Further in Saving Lives - Building a Culture of Safety",
    desc: "Transforming citizens into trained first responders through technology-enabled emergency awareness and community safety training initiatives.",
  },
  {
    org: "Tanla Platforms Limited",
    project: "Cyberabad Traffic Pulse",
    desc: "Leveraging real-time technology and verified alerts to improve urban mobility, reduce congestion, and enhance road safety for citizens.",
  },
  {
    org: "Altius Telecom",
    project: "Technology-enabled Digital Dispensaries",
    desc: "Expanding access to quality healthcare in underserved regions through telemedicine-enabled digital healthcare infrastructure.",
  },
];

/* ─────────────────────────────────────────
   CAROUSEL COMPONENT
───────────────────────────────────────── */
const Carousel = ({ images }) => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);
  const total = images.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  useEffect(() => {
    if (total < 2) return;
    timerRef.current = setInterval(() => setCurrent((c) => (c + 1) % total), 3500);
    return () => clearInterval(timerRef.current);
  }, [total]);

  const hasImages = images.some(Boolean);

  return (
    <CarouselWrap>
      <CarouselTrack>
        {hasImages ? (
          <CarouselImg src={images[current]} alt={`Slide ${current + 1}`} />
        ) : (
          <CarouselPlaceholder>
            <PlaceholderText>Images coming soon</PlaceholderText>
          </CarouselPlaceholder>
        )}
      </CarouselTrack>
      <CarouselControls>
        <CtrlBtn onClick={prev}><FaChevronLeft /></CtrlBtn>
        <Dots>
          {images.map((_, i) => (
            <Dot key={i} active={i === current} onClick={() => setCurrent(i)} />
          ))}
        </Dots>
        <CtrlBtn onClick={next}><FaChevronRight /></CtrlBtn>
      </CarouselControls>
    </CarouselWrap>
  );
};

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
const AwardsAnnouncements = () => {
  return (
    <Section id="awards-announcements">
      <SectionLabel>Highlights</SectionLabel>
      <MainHeading>Awards & Announcements</MainHeading>
      <Divider />

      <Wrapper>

        {/* ── Vidyalakshmi Scholarship ── */}
        <AnnouncementCard>
          <AnnouncementInfo>
            <AnnouncementTag>
              <FaBullhorn /> Announcement
            </AnnouncementTag>
            <AnnouncementTitle>
              Extension of Powergrid Vidyalakshmi Scholarship Scheme
            </AnnouncementTitle>
          </AnnouncementInfo>
          <AnnouncementImageCol>
            {vidyalakshmiImage ? (
              <SlotImg src={vidyalakshmiImage} alt="Vidyalakshmi Scholarship" />
            ) : (
              <SlotPlaceholder>
                <SlotLabel>Image coming soon</SlotLabel>
              </SlotPlaceholder>
            )}
          </AnnouncementImageCol>
        </AnnouncementCard>

        {/* ── Social Impact Awards Block ── */}
        {/* <SocialImpactBlock>
          <SIBlockTitle>
            <FaAward /> IITM Social Impact Awards
          </SIBlockTitle>
          <SIIntro>
            As part of the Technology Summit 2026, the IITM Social Impact Awards recognize
            organizations leveraging technology and CSR to create scalable, inclusive, and
            measurable societal impact.
          </SIIntro>
          <SIIntro>
            Following a rigorous evaluation by an interdisciplinary IIT Madras jury, four
            outstanding organizations have been selected for their exceptional contributions.
          </SIIntro>

          <SISplitLayout>
            
            <SICardsCol>
              {socialImpactAwards.map((a, i) => (
                <SIAwardCard key={i}>
                  <SIOrgBadge>{a.org}</SIOrgBadge>
                  <SIProject>{a.project}</SIProject>
                  <SIDesc>{a.desc}</SIDesc>
                </SIAwardCard>
              ))}
            </SICardsCol>

            
            <SICarouselCol>
              <Carousel images={socialImpactAwardsCarousel} />
            </SICarouselCol>
          </SISplitLayout>
        </SocialImpactBlock> */}

        {/* ── Awards Row ── */}
        <AwardsGrid>  

          

        </AwardsGrid>

      </Wrapper>
    </Section>
  );
};

export default AwardsAnnouncements;


/* ═══════════════════════════════════════
   STYLES
═══════════════════════════════════════ */

const Section = styled.section`
  padding: 20px 20px;
  background: #ffffff;

  @media (max-width: 768px) {
    padding: 36px 14px;
  }
`;

const SectionLabel = styled.p`
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #d6a54f;
  margin-bottom: 10px;
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin: 0 0 16px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: #d6a54f;
  border-radius: 2px;
  margin: 0 auto 18px;
`;

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

/* ── Vidyalakshmi card ── */

const AnnouncementCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0ebe3;
  min-height: 220px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AnnouncementInfo = styled.div`
  background: #faf8f5;
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  border-right: 1px solid #ede8e0;

  @media (max-width: 768px) {
    padding: 24px 20px;
    border-right: none;
    border-bottom: 1px solid #ede8e0;
  }
`;

const AnnouncementTag = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #d6a54f;
`;

const AnnouncementTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const AnnouncementImageCol = styled.div`
  min-height: 220px;
`;

const SlotImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const SlotPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: repeating-linear-gradient(
    135deg,
    #f5f0e8 0px,
    #f5f0e8 18px,
    #ede8e0 18px,
    #ede8e0 36px
  );
`;

const SlotLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #b09060;
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.75);
  padding: 6px 16px;
  border-radius: 20px;
`;

/* ── Social Impact Awards block ── */

const SocialImpactBlock = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 36px 32px;
  box-shadow: 0 4px 22px rgba(0, 0, 0, 0.07);
  border: 1px solid #f0ebe3;

  @media (max-width: 768px) {
    padding: 24px 18px;
  }
`;

const SIBlockTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #791e1b;
  margin: 0 0 14px;
`;

const SIIntro = styled.p`
  font-size: 14px;
  line-height: 1.8;
  color: #4b5563;
  margin: 0 0 8px;
`;

const SISplitLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 24px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SICardsCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const SICarouselCol = styled.div`
  background: #171f32;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const SIAwardCard = styled.div`
  background: #faf8f5;
  border-radius: 14px;
  padding: 22px 20px;
  border-top: 3px solid #d6a54f;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SIOrgBadge = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #791e1b;
  background: #f9e8e8;
  border-radius: 6px;
  padding: 3px 10px;
  align-self: flex-start;
`;

const SIProject = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
  line-height: 1.4;
`;

const SIDesc = styled.p`
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
`;

/* ── Awards grid ── */

const AwardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

/* Partnership Awards card */

const AwardCard = styled.div`
  background: #faf8f5;
  border-radius: 18px;
  padding: 36px 32px;
  border-top: 4px solid #791e1b;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
`;

const AwardIcon = styled.span`
  font-size: 28px;
  color: ${(p) => (p.light ? "#d6a54f" : "#791e1b")};
`;

const AwardYear = styled.span`
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 2px;
  color: ${(p) => (p.light ? "rgba(214,165,79,0.8)" : "#c4a882")};
`;

const AwardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${(p) => (p.light ? "#ffffff" : "#171f32")};
  margin: 0;
  line-height: 1.35;
`;

const AwardDesc = styled.p`
  font-size: 14px;
  color: ${(p) => (p.light ? "#9ca3af" : "#6b7280")};
  margin: 0;
  line-height: 1.6;
`;

/* Social Impact Awards card */

const SocialImpactCard = styled.div`
  background: #171f32;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.13);
  position: relative;
`;

const CarouselOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 24px;
  background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 100%);
  display: flex;
  flex-direction: column;
  gap: 4px;
  pointer-events: none;
`;

const SocialImpactInfo = styled.div`
  padding: 28px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
`;

/* ── Carousel ── */

const CarouselWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CarouselTrack = styled.div`
  flex: 1;
  min-height: 200px;
  overflow: hidden;
`;

const CarouselImg = styled.img`
  width: 100%;
  height: 100%;
  min-height: 200px;
  object-fit: cover;
  display: block;
`;

const CarouselPlaceholder = styled.div`
  width: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: repeating-linear-gradient(
    135deg,
    #1e2740 0px,
    #1e2740 18px,
    #171f32 18px,
    #171f32 36px
  );
`;

const PlaceholderText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #d6a54f;
  letter-spacing: 1px;
  background: rgba(0, 0, 0, 0.35);
  padding: 6px 16px;
  border-radius: 20px;
`;

const CarouselControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  background: #171f32;
`;

const CtrlBtn = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #ffffff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

const Dots = styled.div`
  display: flex;
  gap: 6px;
`;

const Dot = styled.button`
  width: ${(p) => (p.active ? "20px" : "8px")};
  height: 8px;
  border-radius: 4px;
  border: none;
  background: ${(p) => (p.active ? "#ffffff" : "rgba(255,255,255,0.3)")};
  cursor: pointer;
  transition: width 0.3s ease, background 0.3s ease;
  padding: 0;
`;
